var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vueIndexView"},[_c('loading-spinner',{class:{'mt-3 text-center': _vm.settingEnv},attrs:{"showSpinner":_vm.settingEnv,"customClass":"overlay opaque"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }